import { PensionPortfolioService } from "../../../../packages/pension-portfolio/composables/services/pension-portfolio.service"

const selectedPensionPortfolioService = ref<typeof PensionPortfolioService>(PensionPortfolioService)
const additionalParams = ref<Record<string, string>>({})

export const usePensionPortfolioService = () => {
  function setPensionPortfolioService(service: typeof PensionPortfolioService) {
    selectedPensionPortfolioService.value = service
  }

  function setAdditionalParams(params: Record<string, string>) {
    additionalParams.value = params
  }

  return {
    pensionPortfolioService: selectedPensionPortfolioService,
    additionalParams,
    setPensionPortfolioService,
    setAdditionalParams,
  }
}
